import { LINE_ITEM_TYPES, LineItemTypeName } from '@pubstack/common/src/gam/lineItemType'
import { FunctionComponent, useState } from 'react'
import { Checkbox } from '@pubstack/ui/components/Checkbox'
import { WithClassName } from '~/types/utils'

type LineItemTypeSelectorProps = WithClassName & {
  selectedTypes: LineItemTypeName[]
  onTypesSelection: (types: LineItemTypeName[]) => unknown
}

const useTypesSelection = (
  selectedTypes: LineItemTypeName[],
  onTypesSelection: (types: LineItemTypeName[]) => unknown,
  setLocalSelectedTypes: React.Dispatch<React.SetStateAction<LineItemTypeName[]>>
) => {
  const isSelected = (type: LineItemTypeName) => selectedTypes.includes(type)
  const onSelection = (type: LineItemTypeName) => {
    // Build updated types selection
    const updatedTypesSelection = isSelected(type) ? selectedTypes.filter((s) => s !== type) : [...selectedTypes, type]

    // Update local state
    setLocalSelectedTypes(updatedTypesSelection)

    // Propagate to parent component
    onTypesSelection(updatedTypesSelection)
  }

  return { isSelected, onSelection, setLocalSelectedTypes }
}

export const LineItemTypeSelector: FunctionComponent<LineItemTypeSelectorProps> = ({ selectedTypes, onTypesSelection }) => {
  const [localSelectedTypes, setLocalSelectedTypes] = useState(selectedTypes)
  const [previousSelectedTypes, setPreviousSelectedTypes] = useState(selectedTypes)

  const { isSelected, onSelection } = useTypesSelection(localSelectedTypes, onTypesSelection, setLocalSelectedTypes)

  // Re-sync on prop change, during render rather than in an effect
  if (previousSelectedTypes !== selectedTypes) {
    setPreviousSelectedTypes(selectedTypes)
    setLocalSelectedTypes(selectedTypes)
  }
  return (
    <div className="flex flex-wrap py-1 w-125">
      {LINE_ITEM_TYPES.map((type) => {
        return (
          <div key={type.name} className="grow-0 basis-1/2 w-full">
            <Checkbox
              className="h-7.5"
              checked={isSelected(type.name)}
              onClick={(_e) => onSelection(type.name)}
              label={<span className="inline-flex items-center gap-[1ch]">{type.displayName}</span>}
              trackingLabel={isSelected(type.name) ? `adm-refresh-exclusion-by-line-item-type-${type.name}-selection-unset` : `adm-refresh-exclusion-by-line-item-type-${type.name}-selection-set`}
            />
          </div>
        )
      })}
    </div>
  )
}
